var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-start gap"},_vm._l((_vm.approvals),function(a){return _c('v-avatar',{key:a.userID,staticClass:"white--text",attrs:{"color":"indigo","size":"30","title":a.username}},[_vm._v(" "+_vm._s(a.monogram)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }